var initializePosterPage = (function() {
  var articleId;
  var brikPackVariants = {};
  var brikPackVariantData = {};
  var brikPackPrice = -1;
  var brikPackCartData;
  var brikCount = 0;
  var colors = [];
  var colorsData = {};
  var designData;
  var defaultVariantId;
  var defaultSize;
  var isInitialLoad = true;
  var selectionToVariantMap = {};
  var size1x1 = '10" x 10"';
  var size2x2 = '20" x 20"';
  var sizes = [];
  var sizeToTileCount = {[size1x1]: 1, [size2x2]: 4};
  var sizeToZoomFactor = {};
  var sizeToSKUs = {
    [size1x1]: ['BT1WT_1', 'BT1BK_1', 'BT1BL_1'],
    [size2x2]: ['BT1WT_4', 'BT1BK_4', 'BT1BL_4'],
  };
  var skuImageKey = {
    BT1BK_1 : 'poster1x1Black',
    BT1BK_4 : 'poster2x2Black',
    BT1BL_1 : 'poster1x1Blue',
    BT1BL_4 : 'poster2x2Blue',
    BT1WT_1 : 'poster1x1White',
    BT1WT_4 : 'poster2x2White',
  };
  var variantsData;
  var variantsToOptionsMap = {};

  function initializePosterPage(_articleId, _blogId, _designData, _variantsData) {
    articleId = _articleId;
    blogId = _blogId;
    designData = _designData;
    variantsData = _variantsData;
    getColorData();
  }

  function getColorData() {
    var request = $.ajax({
      type: 'GET',
      url: 'https://apps.joltteam.com/internal/brikbuild/colors',
    });

    request.done(function(result) {
      $.each(result, function(_, brikPack) {
        brikPackVariants[brikPack.id] = [];
        $.each(brikPack.variants, function(key, value) {
          brikPackVariants[brikPack.id].push(toInt(key));
          brikPackVariantData[brikPack.id + '_' + key] = {
            price: value.price,
            variant_id: value.id,
          };
        });
        brikPackVariants[brikPack.id].sort(function(a, b) {
          return b - a;
        });
        colorsData[toInt(brikPack.id)] = {
          image: brikPack.variants[25].image,
          name: brikPack.name,
        };
      });
      computePosterSizes();
      startLoading();
    });

    request.fail(function(jqXHR, textStatus) {
      console.log('Error from server, httpStatus:' + jqXHR.status +
        ' message:' + jqXHR.responseText + ';' + textStatus);
    });
  }

  function computePosterSizes() {
    var height = toInt(designData.size.height);
    var width = toInt(designData.size.width);
    if (height <= 32 && width <= 32) {
      sizes.push(size1x1);
      defaultSize = size1x1;
      sizeToZoomFactor[size1x1] = 1;
    }
    if ((height > 16 && height <= 64) ||
        (width > 16 && width <= 64)) {
      sizes.push(size2x2);
      defaultSize = defaultSize || size2x2;
      if (height <= 32 && width <= 32) {
        sizeToZoomFactor[size2x2] = 4;
      } else {
        sizeToZoomFactor[size2x2] = 1;
      }
    }
  }

  function toInt(str) {
    if (str == null) {
      return null;
    }
    return parseInt(str, 10);
  }

  function getDefaultVariant() {
    return getQueryParamAsMap().variant;
  }

  function getDefaultSize() {
    return toInt(getQueryParamAsMap().size);
  }

  function updateURLQueryParam(key, value) {
    if (!history.pushState || !key || !value) {
      return;
    }
    var hashMap = getQueryParamAsMap();
    hashMap[key] = value;
    var keyValues = [];
    $.each(hashMap, function(key, value) {
      keyValues.push([key, value].join('='));
    });
    var newQueryParams = keyValues.join('&');
    if (newQueryParams) {
      var newurl = [
        window.location.protocol,
        '//',
        window.location.host,
        window.location.pathname,
        '?',
        newQueryParams
      ].join('');
      window.history.pushState({path:newurl},'',newurl);
    }
  }

  function getQueryParamAsMap() {
    var hashMap = {};
    var queryParams = decodeURIComponent(window.location.search.substring(1));
    if (!queryParams) {
      return hashMap;
    }
    var hashKeyValues = queryParams.split('&');
    for (var i=0; i < hashKeyValues.length; i++) {
      var keyValue = hashKeyValues[i];
      var keyValueArray = keyValue.split('=');
      hashMap[keyValueArray[0]] = keyValueArray[1];
    }
    return hashMap;
  }

  function computeBrikPackPrice(briks, factor) {
    brikCount = 0;
    var price = 0;
    var cartData = [];
    $.each(briks, function(colorId, count) {
      count = count * factor;
      var variants = brikPackVariants[colorId];
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (count/variant >= 1) {
          var numberOfBrikPack = Math.floor(count/variant);
          count -= numberOfBrikPack * variant;
          brikCount += numberOfBrikPack * variant;
          for (var j = 0; j < numberOfBrikPack; j++) {
            cartData.push(
              brikPackVariantData[colorId + '_' + variant].variant_id
            );
            price += brikPackVariantData[colorId + '_' + variant].price;
          }
        }
        if (count <= 0) {
          break;
        }
        var currentPrice = brikPackVariantData[colorId + '_' + variant].price;
        var nextVariant = variants[i + 1];
        var nextPrice = brikPackVariantData[colorId + '_' + variants[i + 1]]
          ? brikPackVariantData[colorId + '_' + nextVariant].price
          : null;
        if (
          count > largePackCutOffQuantity(currentPrice, nextPrice, nextVariant)
        ) {
          count -= variant;
          brikCount += variant;
          cartData.push(brikPackVariantData[colorId + '_' + variant].variant_id);
          price += brikPackVariantData[colorId + '_' + variant].price;
        }
        if (count <= 0) {
          break;
        }
      }
    });
    brikPackPrice = price * 100;
    brikPackCartData = cartData;
    updateBriksCount();
  }

  function largePackCutOffQuantity(currentPrice, nextPrice, variant2Quantity) {
    if (!nextPrice) {
      return 0;
    }
    const numSmallPacks = Math.floor(currentPrice / nextPrice);
    return numSmallPacks * variant2Quantity;
  }

  function initializeVariantsData() {
    $.each(variantsData, function (_, variant) {
      if (colors.indexOf(variant.color) < 0) {
        colors.push(variant.color);
      }
      selectionToVariantMap[variant.color] = variant;
      variantsToOptionsMap[variant.id] = {
        color: variant.color
      };
    });
  }

  function populateThumbnails() {
    $.each(sizes, function(_, size) {
      populateImagesInMoreView(
        $.map(sizeToSKUs[size], function(key) {
          var result = {url: designData[skuImageKey[key]]};
          return result;
        })
      );
    });
    populateImagesInMoreView(
      $.map(designData.briks, function(_, brikId) {
        return {
          url: colorsData[brikId].image,
          name: colorsData[brikId].name
        };
      })
    );
  }

  function populateImagesInMoreView(images) {
    if (!$('#more-view-carousel').data('owlCarousel')) {
      $('#more-view-carousel').append(
        $.map(images, function(image) {
          return constructThumbnail(image.url, image.name);
        })
      );
    } else {
      $.each(images, function(_, image) {
        $('#more-view-carousel').data('owlCarousel').addItem(
          constructThumbnail(image.url, image.name),
          image.index
        );
      });
    }
  }

  function constructThumbnail(url, name) {
    url = url.replace('https://cdn.apps.joltteam.com', 'https://apps.joltteam.com/cdn');
    var li = $('<li class="grid-item"></li>');
    var a = $('<a href="javascript:void(0)"></a>')
      .data('image', url)
      .data('zoomImage', url);
    a.append($('<img class="img-100" >').attr('src', url));
    if (name) {
      a.attr('alt', name);
    }
    li.append(a);
    return li;
  }

  function startLoading() {
    initializeVariantsData();
    defaultVariantId = getDefaultVariant();
    var defaultVariant = variantsToOptionsMap[defaultVariantId];
    (new SuggestedDesigns(
      '#other-designs',
      '/internal/brikbuild/other-designs',
      articleId,
      blogId
    )).load();
    (new SuggestedDesigns(
      '#similar-designs',
      '/internal/brikbuild/similar-designs',
      articleId,
      blogId,
      similarDesignsHandler
    )).load();
    populateThumbnails();
    $('#color-selector').change(variantChanged)
      .append(
        $.map(colors, function(color) {
          var optionDom = $('<option/>').val(color).html(color);
          if (defaultVariant && defaultVariant.color === color) {
            optionDom.attr('selected', 'selected');
          }
          return optionDom;
        })
      )
      .selectize();

    var _defaultFactor = sizeToTileCount[defaultSize];
    if (isInitialLoad) {
      _defaultFactor = getDefaultSize();
    }
    $('#size-selector').change(variantChanged)
      .append(
        $.map(sizes, function(size) {
          var optionDom = $('<option/>').val(size).html(size);
          if (_defaultFactor === sizeToTileCount[size]) {
            optionDom.attr('selected', 'selected');
          }
          return optionDom;
        })
      )
      .selectize()
      .trigger('change');
    $('#main-loader').hide();
    $('.container').show();
    isInitialLoad = false;
  }

  function similarDesignsHandler(response) {
    if (response.isSimilarArticles) {
      return;
    }
    $('.suggested-designs-header', '#similar-designs').hide();
    $('.suggested-designs-alternative-header', '#similar-designs').show();
  }

  function updateBriksCount() {
    $('#brik-count').html(brikCount);
  }

  function updateTileCount(count) {
    if (count === 1) {
      return $('#tile-description').html(
        '<span class="count">' + count +
          ' </span> Brik Wall Tile (10" x 10") *Removable Adhesive Backing'
      );
    }
    return $('#tile-description').html(
      '<span class="count">' + count +
        ' </span> Brik Wall Tiles (10" x 10" each) *Removable Adhesive Backing'
    );
  }

  function variantChanged() {
    var selectedColor = $('#color-selector option:selected').val();
    var selectedSize = $('#size-selector option:selected').val();
    var selectedVariant = selectionToVariantMap[selectedColor];
    computeBrikPackPrice(designData.briks, sizeToZoomFactor[selectedSize]);
    updateTileCount(sizeToTileCount[selectedSize]);
    updateImage(selectedVariant, sizeToTileCount[selectedSize]);
    updateSelectionAndPrice(selectedVariant, sizeToTileCount[selectedSize]);
    updateQueryParam(selectedVariant, sizeToTileCount[selectedSize]);
  }

  function updateQueryParam(selectedVariant, size) {
    if (isInitialLoad) {
      isInitialLoad = false;
      return;
    }
    if (selectedVariant) {
      updateURLQueryParam('variant', selectedVariant.id);
    }
    if (size) {
      updateURLQueryParam('size', size);
    }
  }

  function updateImage(selectedVariant, size) {
    if (!selectedVariant || !size) {
      return;
    }
    var imageUrl = designData[
      skuImageKey[[selectedVariant.SKU, size].join('_')]
    ];
    if (!imageUrl || imageUrl.length === 0) {
      return;
    }
    updatePhotoSection(imageUrl);
  }

  function updatePhotoSection(imageUrl) {
    imageUrl = imageUrl.replace('https://cdn.apps.joltteam.com', 'https://apps.joltteam.com/cdn');
    $('#product-featured-image').attr('src', imageUrl)
      .data('zoom-image', imageUrl);
    // Reinitialize elevateZoom only if its already initialized.
    if ($('#product-featured-image').elevateZoom) {
      $('.zoomContainer').remove();
      $('#product-featured-image').elevateZoom();
    }
  }

  function updateSelectionAndPrice(selectedVariant, count) {
    if (!selectedVariant) {
      return resetCartForm();
    }
    var cartVariants = brikPackCartData.slice();
    var tilePrice = 0;
    for (var i = 0; i < count; i++) {
      cartVariants.push(selectedVariant.id);
      tilePrice += selectedVariant.price;
    }
    var originalTotal = (
      (tilePrice + brikPackPrice) / 100
    ).toFixed(2);
    var discount = 20;
    var originalDiscountedTotal = (
      originalTotal * (1 - (discount / 100))
    ).toFixed(2);

    updateCartForm(
      originalDiscountedTotal,
      originalTotal,
      discount.toString(),
      cartVariants
    );
  }

  function updateCartForm(
    finalTotal,
    originalTotal,
    discount,
    productVariants
  ) {
    $('.final-price').html('$' + finalTotal);
    $('.original-price').html('$' + originalTotal);
    $('.discount').html('(save ' + discount + '%)');
    var variantCountMap = {};
    $.each(productVariants, function(_, variant) {
      if (!variantCountMap[variant]) {
        variantCountMap[variant] = 0;
      }
      ++variantCountMap[variant];
    });
    var cartUrl = '/cart/';
    $.each(variantCountMap, function(key, val) {
      cartUrl += key + ':' + val + ',';
    });
    cartUrl = cartUrl.slice(0, cartUrl.length - 1);
    cartUrl += '?discount=POSTER20';
    $('#add-to-cart-link').attr('href', cartUrl);
  }

  function resetCartForm() {
    $('#add-to-cart-link').attr('href', '');
  }

  return initializePosterPage;
}());
